define('model/contact.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var ContactModel = BaseModel.extend({
    radioRequests: {
      'models ContactModel': '@constructor',
    },

    urlRoot: '/api/v1/contact',
  });

  module.exports = ContactModel;
});

